// Model for the slider for component sizing and gain ratio
// Component sizing range of values is from 1pf to 910uF
// Gain ratio range of values is from 10ohms to 10MOhms
export default class SliderInput {
  enabled;
  minimum;
  maximum;
  value;

  constructor(args) {
    if (args) {
      this.enabled = args.enabled ?? null;
      this.minimum = args.minimum ?? null;
      this.maximum = args.maximum ?? null;
      this.value = args.value ?? null;
    }
  }
}
